<template>
  <article class="candidate qualification">
    <div
      v-if="qualification.verifiedAt"
      style="position: absolute; right: 1rem; margin-top: -2.4rem"
    >
      <v-tooltip bottom>
        <img slot="activator" src="/img/verified.png" width="30" />
        <span>
          Verified by Leaply on
          {{ new Date(qualification.verifiedAt) | date("d MMMM yyy") }}
        </span>
      </v-tooltip>
    </div>
    <div style="position: absolute; right: 1rem; margin-top: -3rem">
      <Flag
        v-for="(f, i) in flags"
        :key="`qualification-flag-${i}`"
        :value="f"
        icon
      />
    </div>

    <v-card flat>
      <v-layout row wrap align-center fill-height>
        <v-flex xs12 order-xs2 order-md1 v-if="sortedMajors.length > 0">
          <div class="text-xs-center py-3 mt-2">
            <div class="title">
              <span
                v-if="
                  qualification.qualificationType &&
                  qualification.qualificationType.acronym
                "
              >
                {{ qualification.qualificationType.acronym }}
              </span>
              <span v-else>{{ qualification.qualificationTypeName }}</span>
              <span v-if="qualification.specialization"
                >in {{ qualification.specialization }}</span
              >
            </div>
            <div class="subheading" v-if="qualification.institutionName">
              at {{ qualification.institutionName }}
            </div>
            <span
              v-if="requiresProofOfRegistration"
              class="py-2"
              key="missing-proof"
            >
              <v-icon left :class="themes.client.light.warningText"
                >mdi-alert-circle</v-icon
              >
              <span :class="themes.client.light.warningText"
                >Proof of Registration Required</span
              >
            </span>
            <span
              v-if="requiresQualificationTranscript"
              class="py-2"
              key="missing-transcript"
            >
              <v-icon left :color="themes.client.light.warning"
                >mdi-alert-circle</v-icon
              >
              <span :class="themes.client.light.warningText"
                >Transcript Required</span
              >
            </span>
          </div>
        </v-flex>
        <v-flex
          xs12
          md3
          order-xs1
          order-md2
          class="text-xs-center pt-3 mt-2"
          :class="themes.client.light[dateColor]"
        >
          <v-progress-circular
            :color="themes.client.light.secondary"
            :value="completion"
            rotate="-90"
            size="120"
            width="4"
          >
            <v-avatar class="transparent" size="110">
              <img
                :src="logo || '/img/missing/logos/institutions/original.png'"
              />
            </v-avatar>
          </v-progress-circular>
          <div
            v-if="qualification.startsAt || qualification.endsAt"
            class="pt-3"
          >
            <span
              v-if="
                qualification.startsAt &&
                qualification.startsAt !== qualification.endsAt
              "
            >
              {{ new Date(qualification.startsAt) | date("MMM yyy") }} -
            </span>
            <span v-if="qualification.endsAt">
              {{ new Date(qualification.endsAt) | date("MMM yyy") }}
            </span>
          </div>
          <div v-if="qualification.accreditedAt" class="caption">
            <v-tooltip top :color="themes.client.light.tooltip">
              <span slot="activator">
                <v-icon small :class="themes.client.light[dateColor]"
                  >mdi-certificate</v-icon
                >
                {{ new Date(qualification.accreditedAt) | date("d MMMM yyy") }}
              </span>
              <span>Accreditation Date</span>
            </v-tooltip>
          </div>
        </v-flex>
        <v-flex
          xs12
          md6
          order-xs3
          v-if="sortedMajors.length > 0"
          key="qualification-majors"
        >
          <v-flex justify-center>
            <v-list subheader class="transparent">
              <div v-for="(component, i) in sortedMajors" :key="i">
                <v-subheader
                  v-if="i < 1"
                  :style="
                    $vuetify.breakpoint.smAndDown
                      ? 'justify-content: center;'
                      : ''
                  "
                >
                  {{ isSecondary ? "Subjects" : "Majors" }}
                </v-subheader>
                <v-list-tile>
                  <v-list-tile-avatar>
                    <v-avatar size="30" color="white">
                      <v-icon :color="themes.client.light.muted"
                        >mdi-check</v-icon
                      >
                    </v-avatar>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      component.description
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title v-if="component.gradeValue">
                      {{ component.gradeValue }} {{ component.gradeScale }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
            </v-list>
          </v-flex>
        </v-flex>
        <v-flex xs12 md6 order-xs4 v-else key="qualification-description">
          <div class="text-xs-center py-3 mt-2">
            <div class="title">
              <span
                v-if="
                  qualification.qualificationType &&
                  qualification.qualificationType.acronym
                "
              >
                {{ qualification.qualificationType.acronym }}
              </span>
              <span v-else>{{ qualification.qualificationTypeName }}</span>
              <span v-if="qualification.specialization"
                >in {{ qualification.specialization }}</span
              >
            </div>
            <div class="subheading" v-if="qualification.institutionName">
              at {{ qualification.institutionName }}
            </div>
            <span
              v-if="requiresProofOfRegistration"
              class="py-2"
              key="missing-proof"
            >
              <v-icon left :class="themes.client.light.warningText"
                >mdi-alert-circle</v-icon
              >
              <span :class="themes.client.light.warningText"
                >Proof of Registration Required</span
              >
            </span>
            <span
              v-if="requiresQualificationTranscript"
              class="py-2"
              key="missing-transcript"
            >
              <v-icon left :color="themes.client.light.warning"
                >mdi-alert-circle</v-icon
              >
              <span :class="themes.client.light.warningText"
                >Transcript Required</span
              >
            </span>
          </div>
        </v-flex>
        <v-flex
          v-if="qualification.gradeNormalized"
          :class="{ 'pt-3 mt-2': $vuetify.breakpoint.mdAndUp }"
          class="pt-2"
          order-xs5
          xs12
          md3
        >
          <div class="text-xs-center">
            <v-progress-circular
              :value="Number(qualification.gradeNormalized)"
              :color="themes.client.light[gradeColor]"
              :size="120"
              :width="4"
              :rotate="-90"
            >
              <v-avatar size="110">
                <span
                  class="display-1"
                  :class="themes.client.light[`${gradeColor}Text`]"
                >
                  {{ qualification.gradeValue }}
                </span>
              </v-avatar>
            </v-progress-circular>
            <div
              v-if="qualification.gradeScale"
              :class="themes.client.light[`${gradeColor}Text`]"
              class="pt-3"
            >
              {{ qualification.gradeScale }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </article>
</template>

<script>
// Components
import CompletionIndicator from "@/components/client/candidate/profile/qualifications/CompletionIndicator";
import CreateFlag from "@/components/client/flags/CreateFlag";
import Flag from "@/components/candidate/flags/Flag";

// Helpers
import { byGradeValue } from "@/sorting/QualificationComponents";

export default {
  components: { Flag },

  props: {
    flags: { type: Array, default: () => [] },
    profile: { type: Object, required: true },
    qualification: { type: Object, required: true },
    requiresProofOfRegistration: { type: Boolean, default: () => false },
    requiresQualificationTranscript: { type: Boolean, default: () => false },
  },

  computed: {
    completion() {
      const start = this.qualification.start
        ? new Date(this.qualification.start)
        : new Date();
      const end = this.qualification.end
        ? new Date(this.qualification.end)
        : new Date();

      if (end > new Date()) {
        return Math.round(
          (Math.abs(end - new Date()) / Math.abs(end - start)) * 100
        );
      }
      return 100;
    },

    dateColor() {
      const datesFlagged = this.flags.some(
        (f) => f.key.indexOf("qualification_dates") >= 0
      );
      return datesFlagged ? "warningText" : "mutedText";
    },

    gradeColor() {
      const gradeFlagged = this.flags.some(
        (f) => f.key.indexOf("grade_value") >= 0
      );
      return gradeFlagged ? "error" : "primary";
    },

    isSecondary() {
      return (
        _.get(
          this.qualification,
          "qualificationType.qualificationCategory.name"
        ) === "Secondary Education"
      );
    },

    logo() {
      return _.get(this.qualification, "institution.logo");
    },

    sortedMajors() {
      if (!_.get(this.qualification, "profileQualificationComponents"))
        return [];

      const components = JSON.parse(
        JSON.stringify(this.qualification.profileQualificationComponents)
      );
      return components
        .filter((c) => this.isSecondary || _.get(c, "disciplines[0]"))
        .sort(byGradeValue);
    },
  },
};
</script>
